import { GET_INFO_ERROR, GET_INFO_PENDING, GET_INFO_SUCCESS } from './actionType';

const INITIAL_STATE = {
  info: {}
};

const reducer = (state = INITIAL_STATE, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_INFO_PENDING:
      return {
        ...state,
        ...{
          infoLoading: true
        }
      };

    case GET_INFO_SUCCESS:
      return {
        ...state,
        ...{
          infoLoading: false,
          info: payload,
          infoError: false,
          infoErrorMessage: null
        }
      };

    case GET_INFO_ERROR:
      return {
        ...state,
        ...{
          infoLoading: false,
          infoError: true,
          infoErrorMessage: payload
        }
      };

    default:
      return state;
  }
};

export default reducer;
